module.exports = __webpack_public_path__ + "img/11zcgj.7a217c00.svg";